import { Link, Image } from '../../Atoms'
import { ImgType } from './props'

//////// HELPER METHODS ////////
export const mapGoogleURL = (src: string) => {
    const params = src.split('/')
    const imageId = params[params.length - 2]
    const url = `https://drive.google.com/uc?id=${imageId}`
    return url
}

export const mapURL = (src?: string) => {
    if (!src) return ''
    const isGoogleDrive = src.includes('drive.google.com')
    return isGoogleDrive ? mapGoogleURL(src) : src
}

//////// CUSTOM COMPONENTS ////////
const ImageMD = (prop: ImgType) => {
    const url = mapURL(prop.src)
    return <Image src={url} />
}

const LinkMD = ({ children, props }: any) => {
    return <Link {...props}>{children}</Link>
}

//////// DICTIONARY ////////
export const CustomComponents = {
    a: LinkMD,
    img: ImageMD,
}
